module.exports = __webpack_public_path__ + "static/img/scan qr.ce745ee1.png";